module.exports = __webpack_public_path__ + "static/media/ProfessionalImg.fa94a85a.svg";